// extracted by mini-css-extract-plugin
module.exports = {"ctaButton":"styles_ctaButton__uiA8R","disableBorder":"styles_disableBorder__Mb_8N"};